<template>
  <div id="app">
 <AppHeader/>
  <div style="margin-top:164px">
    <navbar />
    <!-- <carousel/> -->
    <magdalena-carousel/>
    <card1/>
    <card2/>
    <carddeck2/>
    <TestimonialsList/>
    <card3/>
  </div>
  <AppFooter/>
  
  <router-view></router-view>

  </div>
 

</template>

<script>
import Header from './components/Header.vue';
import Navbar from './components/Navbar.vue';
import Carousel from './components/Carousel.vue';
import Card1 from './components/Card1'
import Card2 from './components/Card2.vue';
import Carddeck2 from './components/Carddeck2.vue';
import Card3 from './components/Card3.vue';
import Footer from './components/Footer.vue';
import MagdalenaCarousel from './components/MagdalenaCarousel.vue';
import TestimonialsList from './components/Testimonials/TestimonialsList'

export default {
  name:'App',
  components: {
  AppHeader: Header,
  Navbar,
  // Carousel,
  Card1, 
  Card2,
  Carddeck2,
  Card3,
  AppFooter: Footer,
  MagdalenaCarousel,
   TestimonialsList
   
  }

};

</script>

<style>
  body{
    background: white;
    font-family: "Lato", sans-serif;
  }
  .hyper-section{
    position: relative;
    top: -160px;
  }
</style>